<template>
  <div class="feature-list__one" v-if="items">
    <div class="row">
      <div v-for="(item, x) in items.data.items" :key="x" class="col-lg-6 wow move-up" :id="item.id">
        <div class="grid-item animate">
          <div class="ht-box-icon style-01">
            <div class="icon-box-wrap">
              <div class="content">
                <h6 class="heading">{{ item.heading }}</h6>
                <div class="text" v-html="`${item.text}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FeatureAppTwo',
  computed: {
    items() {
      return this.$store.getters['app/content']('498658b1-5934-43ac-a2b9-30125f51842c')
    }
  }
}
</script>
